<template>
  <div class="index">
      <headerPage></headerPage>
      <!-- 顶部横幅 -->
      <div class="index-search">
          <div class="deco deco-1"></div>
          <div class="deco deco-2"></div>
          <div class="deco-ring"></div>
          <div class="index-search-content">
              <div class="search-content">
                <div class="content2"><i class="el-icon-magic-stick"></i> CODING FOR KIDS · AI FOR FUTURE</div>
                <div class="content4">专业的<span class="grad-text">青少年人工智能</span>学习平台，让孩子爱上编程</div>
                <div class="content6">Scratch 图形化编程 · Python 人工智能 · C++ 算法竞赛，</div>
                <div class="content6">跟随老师的班级课程，一步一步成为编程小达人！</div>
                <div class="search-wrap">
                    <el-input class="searchKey" v-model="searchKey" placeholder="搜索想要学习的课程" @change="searchTask()"></el-input>
                    <div class="search-btn" @click="searchTask()"><i class="el-icon-search"></i>搜索</div>
                </div>
              </div>
            </div>
          <div class="index-image">
            <img class="index-search-image" src="../../assets/image/index/index-image.png"/>
          </div>
      </div>
      <!-- 编程课程 -->
      <div class="most-major">
          <div class="most-content"> 
              <div class="page-title">
                <div class="section-title">编程课程</div>
                <div class="section-sub">选择你感兴趣的课程分类，开启编程之旅 <span class="grad-text">Programming Courses</span></div>
              </div>
              <div class="major-list">
                <div class="major-item" v-for="(item,index) in classificationList" :key="index" @click="classificationTask(item.name)">
                    <div class="major-icon" :class="'major-icon-' + (index % 6)">
                        <i v-if="item.name && item.name.toLowerCase().indexOf('scratch') >= 0" class="el-icon-cpu"></i>
                        <i v-else-if="item.name && item.name.toLowerCase().indexOf('python') >= 0" class="el-icon-lollipop"></i>
                        <i v-else-if="item.name && item.name.toLowerCase().indexOf('c++') >= 0 || item.name && item.name.toLowerCase().indexOf('cpp') >= 0" class="el-icon-medal-1"></i>
                        <i v-else class="el-icon-magic-stick"></i>
                    </div>
                    <div class="major-name">{{item.name}}</div>
                    <div class="major-go"><i class="el-icon-right"></i></div>
                </div>
              </div>
          </div>
      </div>
      <!-- 平台数据 -->
      <div class="shuju">
          <div class="most-content">
              <div class="page-title">
                <div class="section-title">平台数据</div>
                <div class="section-sub">我们的成长与积累 <span class="grad-text">Our Achievement</span></div>
              </div>
              <div class="shuju-total">
                  <div class="shuju-item">
                      <div class="shuju-icon shuju-icon-1"><i class="el-icon-user"></i></div>
                      <div class="shuju-name">
                          <div class="shuju-num">{{data.count1}}+</div>
                          <div class="shuju-label">认证教师</div>
                      </div>
                  </div>
                  <div class="shuju-item">
                      <div class="shuju-icon shuju-icon-2"><i class="el-icon-video-play"></i></div>
                      <div class="shuju-name">
                          <div class="shuju-num">{{data.count}}+</div>
                          <div class="shuju-label">视频课程</div>
                      </div>
                  </div>
                  <div class="shuju-item">
                      <div class="shuju-icon shuju-icon-3"><i class="el-icon-s-custom"></i></div>
                      <div class="shuju-name">
                          <div class="shuju-num">{{data.count2}}+</div>
                          <div class="shuju-label">在读学生</div>
                      </div>
                  </div>
                  <div class="shuju-item">
                      <div class="shuju-icon shuju-icon-4"><i class="el-icon-star-on"></i></div>
                      <div class="shuju-name">
                          <div class="shuju-num">{{data.total}}+</div>
                          <div class="shuju-label">平台用户</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- 优秀学员 -->
      <div class="most-note">
          <div class="most-content">
              <div class="page-title">
                <div class="section-title">优秀学员</div>
                <div class="section-sub">看看小伙伴们的高光时刻 <span class="grad-text">Excellent Students</span></div>
              </div>
              <div class="students-empty">
                  <div class="students-empty-icon"><i class="el-icon-trophy"></i></div>
                  <div class="students-empty-text">优秀学员展示区 · 下一个上榜的就是你！</div>
              </div>
          </div>
      </div>

    <bottomPage></bottomPage>
  </div>
</template>

<script>
  import {getDictByCode,getIndexAchievement,getApeClassificationList} from '../../api/api' 
  import headerPage from "../../components/header/header"
  import bottomPage from "../../components/bottom/bottom" 
  export default {
    data() {
      return{
        searchKey: "",
        classificationList: [],
        data: {
            count: 0,
            count1: 0,
            count2: 0,
            total: 0
        },
      }
    },
    components: {
		headerPage,
        bottomPage
	},
    methods: {
        searchTask() {
            if (this.searchKey) {
                this.$router.push("/task?name=" + this.searchKey)
            }
        },
        classificationTask(name) {
            this.$router.push("/task?classification=" + name)
        },
        toMessage() {
            this.$router.push("/message")
        },
        loadClassifications() {
            getApeClassificationList().then(res => {
                if(res.code == 1000) {
                    this.classificationList = res.data
                } else {
                    this.$notify.error({
                    title: '错误',
                    message: res.message
                    });
                }
            })
        },
        getIndexAchievement() {
            getIndexAchievement().then(res => {
                if(res.code == 1000) {
                    this.data = res.data
                } else {
                    this.$notify.error({
                    title: '错误',
                    message: res.message
                    });
                }
            })
        }
    },
    created() {
     
    },
    mounted() {
      this.loadClassifications()
      this.getIndexAchievement()
    }
 }
</script>

<style scoped>
  @import url("../../assets/css/index/index.css");
</style>
